const registerMandatoryFieldsSet = new Set([
    // "gender",
    "first_name",
    "last_name",
    "email",
    "password1",
    "password2",
    "address",
    "city",
    "postal_code",
    "country",
    "phone_code",
    "phone_number",
])

export default registerMandatoryFieldsSet